import React, { useEffect } from "react";
import "./App.css";
import "../src/assets/css/style.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import MyRouts from "./Routers/routes";
import "bootstrap/dist/css/bootstrap.min.css";
import { useDispatch, useSelector } from "react-redux";
import { getProfile } from "store/Profile/actions";

function App() {
  const isAuthenticated = useSelector((s) => s?.login?.token);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(getProfile());
    }
  }, []);
  // console.log(isAuthenticated)
  return (
    <div className="App">
      <MyRouts isAuthenticated={isAuthenticated} />
    </div>
  );
}

export default App;
